import axios from 'axios'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import authService from '../../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  //TitlePage2,
  //TitlePage3
} from '../../../Components/Main'
import ProfileDireita from '../../../Components/ProfileDireita'
//import { NavDireita } from '../../../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../../../Components/SideBar-right/SidebarMobile'
import '../../../styles/pages/SubMenuPages/SubMenuPessoas/SubMenuPessoas.css'
import Modal from '../../MenuDireito/MenuDireito-Modal/ModalCadSubMenuPessoa'
import ModalEditarSub from '../../MenuDireito/MenuDireito-Modal/ModalEdiSubMenuPessoa'

function SubMenuPessoas() {
  var user = authService.getCurrentUser()
  const [pessoas, setPessoas] = useState<any[]>([])
  const [modalInfo, setModalInfo] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/pessoa/list/' +
          user[0].IdEmpresa +
          '/' +
          0
      )
      .then(response => {
        setPessoas(response.data)
      })
  }, [])
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }

  const [modalOpen, setModalOpen] = useState(false)
  return (
    <div className="displayInteract">
      {modalOpen && (
        <ModalEditarSub setOpenModal={setModalOpen} modalInfo={modalInfo} />
      )}
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>

        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>CADASTRO GERAL DE PESSOAS</TitlePage1>
            {/* <TitlePage2>Cadastro Geral de Pessoas</TitlePage2> */}
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <Modal />
          </div>
        </div>
        <div className="tabelaPadrao">
          <table>
            <thead>
              <th>
                <p className="ttlTbl">Vinculo</p>
              </th>
              <th>
                <p className="ttlTbl">Nome</p>
              </th>
              <th>
                <p className="ttlTbl">E-Mail/login</p>
              </th>
              <th>
                <p className="ttlTbl">Web</p>
              </th>
              <th>
                <p className="ttlTbl">App</p>
              </th>
              <th>
                <p className="ttlTbl">Ativo</p>
              </th>
            </thead>
            <tbody>
              {pessoas
                .filter(val => {
                  if (searchTerm === '') {
                    return val
                  } else if (
                    val.pesNome
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    val.pesEmail
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(pessoa => (
                  <tr key={pessoa.IdPessoa}>
                    <td>
                      <Link to={'/VinculoUnidade/' + pessoa.IdPessoa}>
                        <button className="btnMGUPermissoes">
                          <i className="fas fa-bars"></i>
                        </button>
                      </Link>
                    </td>
                    <td onClick={() => handleToggleComplete(pessoa)}>
                      {pessoa.pesNome}
                    </td>
                    <td onClick={() => handleToggleComplete(pessoa)}>
                      {pessoa.pesEmail}
                    </td>

                    <td>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!pessoa.pesAcessoWeb}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>

                    <td>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!pessoa.pesAcessoApp}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>

                    <td>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!pessoa.pesStatus}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        {/* <NavDireita /> */}
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default SubMenuPessoas
